import Cookies from "js-cookie";

const emptyCartCookieName = 'empty_cart_was_displayed';

export const getEmptyCartWasDisplayed = () => Boolean(Cookies.get(emptyCartCookieName));
export const setEmptyCartWasDisplayed = () => Cookies.set(emptyCartCookieName, 'true', { expires: 3 });
